import {
  type AnyRouteConfiguration,
  type RouteConfiguration,
  SEARCH_CONTEXT,
} from "@/search/routes";
import type { Permission } from "@/types/account";
import type { Newsletter } from "@/types/newsletter";

const DEMO_EXCLUSION: string[] = ["Danger Zone"];

export const MAIN_NAVIGATION: RouteConfiguration[] = [
  SEARCH_CONTEXT["/home"],
  SEARCH_CONTEXT["/inbox"],
  SEARCH_CONTEXT["/subscribers"],
  SEARCH_CONTEXT["/emails"],
  SEARCH_CONTEXT["/tags"],
  SEARCH_CONTEXT["/automations"],
  SEARCH_CONTEXT["/comments"],
  SEARCH_CONTEXT["/forms"],
  SEARCH_CONTEXT["/surveys"],
  SEARCH_CONTEXT["/feeds"],
  SEARCH_CONTEXT["/sponsorships"],
  SEARCH_CONTEXT["/analytics"],
  SEARCH_CONTEXT["/settings/paid-subscriptions"],
];

export const API_NAVIGATION: AnyRouteConfiguration[] = [
  SEARCH_CONTEXT["/events"],
  SEARCH_CONTEXT["/keys"],
  SEARCH_CONTEXT["/platform"],
  SEARCH_CONTEXT["/requests"],
  SEARCH_CONTEXT["/webhooks"],
];

export const SETTINGS_NAVIGATION: AnyRouteConfiguration[] = [
  SEARCH_CONTEXT["/settings/general"],
  SEARCH_CONTEXT["/settings/archives"],
  SEARCH_CONTEXT["/settings/email"],
  SEARCH_CONTEXT["/settings/embedding"],
  SEARCH_CONTEXT["/settings/subscribing"],
  SEARCH_CONTEXT["/settings/integrations"],
  SEARCH_CONTEXT["/settings/team"],
  SEARCH_CONTEXT["/settings/data"],
];

export const ACCOUNT_NAVIGATION: AnyRouteConfiguration[] = [
  SEARCH_CONTEXT["/settings/profile"],
  SEARCH_CONTEXT["/settings/notifications"],
  SEARCH_CONTEXT["/settings/security"],
  SEARCH_CONTEXT["/settings/referrals"],
  SEARCH_CONTEXT["/settings/billing"],
  SEARCH_CONTEXT["/settings/danger-zone"],
];

export const canShowRoute = (
  config: AnyRouteConfiguration,
  {
    isDemo = false,
    newsletter,
    permissions,
  }: {
    isDemo?: boolean;
    newsletter?: Newsletter | null;
    permissions?: Permission["permissions"];
  }
): boolean => {
  const { title, feature, permission, hide } = config;

  if (feature !== undefined) {
    if (!newsletter) {
      return false;
    }

    if (!newsletter.enabled_features.includes(feature)) {
      return false;
    }
  }

  if (permission !== undefined) {
    if (!permissions) {
      return false;
    }

    const grant = permissions[permission];

    const canRead = grant === "read";
    const canWrite = grant === "write";

    if (!canRead && !canWrite) {
      return false;
    }
  }

  if (isDemo && title) {
    if (DEMO_EXCLUSION.includes(title)) {
      return false;
    }
  }

  if (hide !== undefined && permissions && newsletter) {
    if (hide(permissions, newsletter)) {
      return false;
    }
  }

  return true;
};
